module.exports = __webpack_public_path__ + "img/RBS_event_01_loading.4edc6795.png";